import { render, staticRenderFns } from "./assess.vue?vue&type=template&id=6f60b118&scoped=true"
import script from "./assess.vue?vue&type=script&lang=js"
export * from "./assess.vue?vue&type=script&lang=js"
import style0 from "./assess.vue?vue&type=style&index=0&id=6f60b118&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f60b118",
  null
  
)

export default component.exports